import { Link } from "wouter";

export default function PrivacyPolicy() {
  return (
    <main className="min-h-screen bg-slate-50 px-4 py-16 md:py-24">
      <article className="mx-auto max-w-4xl rounded-2xl bg-white px-6 py-10 shadow-sm ring-1 ring-slate-200 md:px-12 md:py-14">
        <Link href="/" className="text-sm font-semibold text-blue-700 hover:text-blue-900">
          Back to home
        </Link>
        <p className="mt-10 text-sm font-semibold uppercase tracking-[0.2em] text-blue-600">Legal information</p>
        <h1 className="mt-3 text-4xl font-bold tracking-tight text-slate-950 md:text-5xl">Privacy Policy</h1>
        <p className="mt-4 text-sm text-slate-500">Last updated: September 17, 2026</p>

        <div className="mt-10 space-y-8 text-base leading-8 text-slate-700">
          <section>
            <h2 className="text-2xl font-bold text-slate-950">About this site</h2>
            <p className="mt-3">
              IGETALIBAR is an English-language information and support site for Australian visitors. It provides product information, guides, frequently asked questions, and public location-discovery tools. This site is not the product sales website and does not process product orders or payments.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-slate-950">Information we may receive</h2>
            <p className="mt-3">
              We may receive technical information needed to operate and protect the site, such as browser type, device information, approximate location derived from network data, pages viewed, and basic diagnostic logs. If you sign in or submit information through an available support feature, we may receive the details you choose to provide.
            </p>
            <p className="mt-3">
              Location searches are used to provide nearby public map information when you request it. Please do not submit sensitive personal information into a location search or support form.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-slate-950">How information is used</h2>
            <p className="mt-3">
              Information may be used to operate, maintain, secure, troubleshoot, and improve this information platform; respond to support requests; understand general site usage; and comply with applicable legal obligations. We do not use this site to complete transactions or collect payment details.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-slate-950">Third-party services and links</h2>
            <p className="mt-3">
              The site may rely on infrastructure, authentication, analytics, mapping, hosting, and security providers. Their handling of information is governed by their own terms and privacy notices. Links to the authorised sales entry or external websites take you to services outside this site’s control; review their policies before providing information.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-slate-950">Retention and security</h2>
            <p className="mt-3">
              We retain information only for as long as reasonably necessary for the purposes described above, operational records, security, dispute handling, or legal requirements. Reasonable technical and organisational safeguards are used, but no internet transmission or storage system can be guaranteed completely secure.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-slate-950">Your questions</h2>
            <p className="mt-3">
              If you have a privacy question or want to ask about information submitted through this site, use the available support channel or contact the site operator through the authorised support route. We may need to verify a request before acting on it.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-slate-950">Policy updates</h2>
            <p className="mt-3">
              This policy may be updated when the site, its services, or applicable requirements change. The latest version will be published on this page with its updated date.
            </p>
          </section>
        </div>
      </article>
    </main>
  );
}
